var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00003 11.1698L1.83003 6.99984L0.410034 8.40984L6.00003 13.9998L18 1.99984L16.59 0.589844L6.00003 11.1698Z",
    fill: "#64C1B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanCheckmark);
export default __webpack_public_path__ + "static/media/plan-checkmark.9ca05c67ae5c24d91ca2c1291a3f821a.svg";
export { ForwardRef as ReactComponent };